export default __webpack_public_path__ + "static/media/RE.49693a5f.svg";